export const useSxStyles = () => {
  return {
    widgetActions: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-evenly',
      height: 'auto',
    },
  };
};
